import { PropsWithChildren } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

type RowProps = {
  onClick?: VoidFunction;
  className?: any;
  isActive?: boolean;
};

export const Row = (props: PropsWithChildren<RowProps>): JSX.Element => (
  <div
    className={classNames(styles.row, "hoverBg", props.className, {
      [styles.isActive]: !!props.isActive,
    } as any)}
    onClick={props.onClick}
  >
    {props.children}
  </div>
);
